/** @file poseCommands: the viewport's keying handlers (reset to rest, mirror to twin) via the shell. */
import { mirrorToTwin } from '../../shell/menu/mirrorToTwin';
import { resetToRest } from '../../shell/menu/resetToRest';
import type { ViewportCtx } from './viewportCtx';

/** Runs `act` on the selection, or tells the user to select a joint first. */
function onSelection(ctx: ViewportCtx, label: string, act: (nodes: string[]) => void): void {
  const s = ctx.store.getState();
  if (s.selection.nodes.length === 0) { s.notify('info', `${label}: select a joint first.`); return; }
  act(s.selection.nodes);
}

/**
 * `viewport.pose.rest` (Alt+R: rest values on the selection, the shell's `resetToRest`) and `viewport.pose.mirror`
 * (M: `clip.mirrorPose` of the selection onto its twins, the shell's `mirrorToTwin`); the menus call the same two.
 */
export function poseCommands(ctx: ViewportCtx): Record<string, () => void> {
  return {
    'viewport.pose.rest': () => { onSelection(ctx, 'Reset to rest', (nodes) => { resetToRest(ctx.store, nodes); }); },
    'viewport.pose.mirror': () => { onSelection(ctx, 'Mirror to twin', (nodes) => { mirrorToTwin(ctx.store, nodes); }); },
  };
}
